const env = { ...process.env, ...window.env }

export default env
